import { Spinner } from './Spinner'

export function FullPageSpinner() {
  return (
    <div className='flex flex-col justify-center items-center text-6xl h-screen'>
      <Spinner />
    </div>
  )
}
